import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const IconButton = forwardRef((props, ref) => <BaseButton ref={ref} iconOnly {...props} />);

export default IconButton;
